import React from 'react';

import { InboxOutlined } from '@ant-design/icons';
import { message } from 'antd';
import { ColProps as AntdColProps } from 'antd/lib/grid/col';
import { RcFile } from 'antd/lib/upload';
import Dragger from 'antd/lib/upload/Dragger';

import { getFileOrUndefinedOrThrow } from 'typeGuards/typeGuards';
import { CSSUtils } from 'utils/CSSUtils';

import { useBaseFormContext } from './BaseFormContext';

interface BaseUploaderProps {
  acceptedFilesTypes?: string[];
  maxFileSize?: number;
  placeholder?: string;
}

export const uploaderFullWidthColProps: {
  labelCol: AntdColProps;
  wrapperCol: AntdColProps;
} = {
  labelCol: {
    className: 'hiddenLabel',
    span: 0,
  },
  wrapperCol: { span: CSSUtils.fullWidthCol },
};

export default function BaseUploader<FormValues>({
  acceptedFilesTypes,
  maxFileSize,
  placeholder = 'Joindre un document',
}: Readonly<BaseUploaderProps>): React.ReactElement {
  const form = useBaseFormContext<FormValues>();

  function handleBeforeUpload(file: RcFile) {
    if (!checkFileType(file)) {
      return false;
    }
    if (!checkFileSize(file)) {
      return false;
    }
    updateForm(file);
    return false;
  }

  function checkFileType(file: RcFile): boolean {
    const isFileSupported = acceptedFilesTypes?.includes(file.type);
    if (acceptedFilesTypes && !isFileSupported) {
      void message.error(`${file.name} n'est pas dans un format supporté`);
      updateForm(undefined);
      return false;
    }
    return true;
  }

  function checkFileSize(file: RcFile): boolean {
    if (maxFileSize && file.size > maxFileSize) {
      void message.error(`${file.name} dépasse le poids maximal autorisé`);
      updateForm(undefined);
      return false;
    }
    return true;
  }

  function updateForm(file?: RcFile) {
    form.setFieldValue('file', file);
    void form.validateFields();
  }

  function getTitle() {
    const file: File | undefined = getFileOrUndefinedOrThrow(
      form.getFieldValue('file'),
    );
    return file?.name ?? placeholder;
  }

  return (
    <div className={'uploaderFullWidthRoot'}>
      <Dragger
        name={'file'}
        multiple={false}
        showUploadList={false}
        beforeUpload={handleBeforeUpload}
      >
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="Uploadtitle">{getTitle()}</p>
      </Dragger>
    </div>
  );
}
